import {
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewChild,
} from "@angular/core";
import { ChartConfiguration, ChartType } from "chart.js";
import * as _ from "lodash";
import { SharedDataService } from "../../../../shared/sharedData.service";

@Component({
    selector: "pending-timecards-chart",
    templateUrl: "./pending-timecard.component.html",
    standalone: false
})
export class PendingTimecardComponent implements OnChanges, OnInit {
    constructor(private _sharedDataService: SharedDataService) {}

    @ViewChild("pendingTcCanvas") pendingTcCanvas?: ElementRef;
    @Input() chartData: any = {};
    departments: any = [];
    selectedBusinessUnit: any = {};
    totaltimecards: any;

    public doughnutChartData: any;
    public doughnutChartType = "doughnut";
    public doughnutChartColors = [
        {
            backgroundColor: ["#7aa7ef", "#4a4f59", "#18af4b", "#5c0b72"],
        },
    ];
    public chartOptions = {
        responsive: false,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: { display: false },
    };

    public doughnutChartOptions: ChartConfiguration<"doughnut">["options"] = {
        responsive: true,
        elements: {
            arc: {
                borderWidth: 0,
            },
        },
        plugins: {
            datalabels: {
                display: false,
            },
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
                titleColor: "white",
                displayColors: true,
                backgroundColor: "black",
            },
        },
        cutout: "80%",
    };

    onDataChange() {
        const ChartData = [
            this.chartData.operationTimecard,
            this.chartData.talentTimecard,
            this.chartData.financeTimecard,
            this.chartData.payrollTimecard,
        ];

        this.doughnutChartData = {
            labels: ["Submitters", "Approvers", "Finance", "Payroll"],
            datasets: [
                {
                    data: ChartData,
                    backgroundColor:
                        this.doughnutChartColors[0].backgroundColor,
                    // hoverBackgroundColor:
                    //     this.doughnutChartColors[0].backgroundColor,
                    hoverBorderColor: "#CCC",
                    fillColor: this.doughnutChartColors[0].backgroundColor,
                    strokeColor: this.doughnutChartColors[0].backgroundColor,
                    pointColor: this.doughnutChartColors[0].backgroundColor,
                    pointHighlightStroke:
                        this.doughnutChartColors[0].backgroundColor,
                    hoverOffset: 2,
                    hoverBorderWidth: 3
                },
            ],
        };

        this.totaltimecards =
            this.chartData.operationTimecard +
            this.chartData.talentTimecard +
            this.chartData.financeTimecard +
            this.chartData.payrollTimecard;
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === "chartData") {
                const current = changes["chartData"]["currentValue"];
                this.chartData = current;

                this.departments = _.get(current, "departmentInfo");
                this.onDataChange();
            }
        }
    }

    ngOnInit() {
        this._sharedDataService
            .getSelectedBusinessUnit()
            .subscribe(
                (selectedBu) => (this.selectedBusinessUnit = selectedBu)
            );
    }
}
